
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5762',
  depVersions: {
  "data-privacy-request-ui": "static-1.5762",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9901",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8272",
  "hub-http-shared-msw-handlers": "static-1.10520",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11728",
  "I18n": "static-7.1661",
  "jasmine-runner": "static-1.6694",
  "quartz": "static-1.7362",
  "react-dlb": "static-1.84",
  "rpc-client-utils": "static-1.4907",
  "ui-components-test-utils": "static-1.5865",
  "UIComponents": "static-3.8674",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.89",
  "foundations-assets": "static-1.5120",
  "foundations-components": "static-1.8379",
  "foundations-components-test-utils": "static-1.5862",
  "foundations-theming": "static-1.4700",
  "hub-http": "static-1.6456",
  "quartz-config": "static-1.1140",
  "quartz-core": "static-1.6581",
  "quartz-routing": "static-1.792",
  "quick-fetch": "static-1.4091",
  "raven": "static-3.5925",
  "react": "static-7.190",
  "react-rhumb": "static-1.16952",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11389",
  "usage-tracker": "static-1.7600",
  "usage-tracker-anonymous": "static-1.6017",
  "usage-tracker-core": "static-1.7450",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3574",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3639",
  "quartz-webpack": "static-1.3586",
  "bend-plugin-quartz-routing": "static-1.440",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "HeadJS": "static-2.789",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3383",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "ts-schema": "static-1.4253",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "react-utils": "static-2.5513",
  "StyleGuideUI": "static-3.495",
  "jasmine": "static-4.4563",
  "bend-plugin-chirp-manifest": "static-1.317",
  "chirp-fetch": "static-1.2133",
  "HubStyle": "static-2.12035",
  "ui-addon-draggable": "static-3.5000",
  "cssUtils": "static-1.869",
  "hs-story-utils": "static-1.9670",
  "icons": "static-2.674",
  "react-create-root-preference": "static-1.60",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.103",
  "ui-images": "static-2.1229",
  "bend-plugin-foundations-components": "static-1.4648",
  "floating-ui": "static-1.60",
  "foundations-theming-specialty": "static-1.2416",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2458",
  "ui-fonts": "static-1.990",
  "foundations-components-legacy": "static-1.1404",
  "bend-plugin-foundations-theming": "static-1.3183",
  "foundations-theming-base": "static-1.3685",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.253",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.867",
  "hubspotter-http": "static-1.4823",
  "mobile-manifest-mixins": "static-1.565",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1037",
  "quartz-head": "static-1.1027",
  "quartz-i18n": "static-1.1037",
  "quartz-test": "static-1.1037",
  "quartz-tracking": "static-1.741",
  "trellis-components": "static-1.2477",
  "usage-tracker-container": "static-1.7590",
  "csstype": "static-1.50",
  "web-vitals": "static-1.10",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3358",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.74",
  "sassPrefix": "static-1.161",
  "hubspotter-http-shared-msw-handlers": "static-1.10518",
  "usage-tracker-session-replay": "static-1.5286",
  "base-ui": "static-1.18",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1205",
  "tanstack-virtual": "static-1.35",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5762",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9901",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8272",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10520",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11728",
  "I18n": "/I18n/static-7.1661",
  "jasmine-runner": "/jasmine-runner/static-1.6694",
  "quartz": "/quartz/static-1.7362",
  "react-dlb": "/react-dlb/static-1.84",
  "rpc-client-utils": "/rpc-client-utils/static-1.4907",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5865",
  "UIComponents": "/UIComponents/static-3.8674",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "foundations-assets": "/foundations-assets/static-1.5120",
  "foundations-components": "/foundations-components/static-1.8379",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5862",
  "foundations-theming": "/foundations-theming/static-1.4700",
  "hub-http": "/hub-http/static-1.6456",
  "quartz-config": "/quartz-config/static-1.1140",
  "quartz-core": "/quartz-core/static-1.6581",
  "quartz-routing": "/quartz-routing/static-1.792",
  "quick-fetch": "/quick-fetch/static-1.4091",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.190",
  "react-rhumb": "/react-rhumb/static-1.16952",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11389",
  "usage-tracker": "/usage-tracker/static-1.7600",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6017",
  "usage-tracker-core": "/usage-tracker-core/static-1.7450",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3574",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3639",
  "quartz-webpack": "/quartz-webpack/static-1.3586",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.440",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "HeadJS": "/HeadJS/static-2.789",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3383",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "ts-schema": "/ts-schema/static-1.4253",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "react-utils": "/react-utils/static-2.5513",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "jasmine": "/jasmine/static-4.4563",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.317",
  "chirp-fetch": "/chirp-fetch/static-1.2133",
  "HubStyle": "/HubStyle/static-2.12035",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5000",
  "cssUtils": "/cssUtils/static-1.869",
  "hs-story-utils": "/hs-story-utils/static-1.9670",
  "icons": "/icons/static-2.674",
  "react-create-root-preference": "/react-create-root-preference/static-1.60",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.103",
  "ui-images": "/ui-images/static-2.1229",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4648",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2416",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2458",
  "ui-fonts": "/ui-fonts/static-1.990",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1404",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3183",
  "foundations-theming-base": "/foundations-theming-base/static-1.3685",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.253",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.867",
  "hubspotter-http": "/hubspotter-http/static-1.4823",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.565",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1037",
  "quartz-head": "/quartz-head/static-1.1027",
  "quartz-i18n": "/quartz-i18n/static-1.1037",
  "quartz-test": "/quartz-test/static-1.1037",
  "quartz-tracking": "/quartz-tracking/static-1.741",
  "trellis-components": "/trellis-components/static-1.2477",
  "usage-tracker-container": "/usage-tracker-container/static-1.7590",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.10",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.74",
  "sassPrefix": "/sassPrefix/static-1.161",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10518",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5286",
  "base-ui": "/base-ui/static-1.18",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1205",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
